"use strict";
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var JS_1 = require("../JS");
var StorageHelper_1 = require("../StorageHelper");
var Linking = {};
exports.Linking = Linking;
var AppState = {
    addEventListener: function (action, handler) {
        return;
    }
};
exports.AppState = AppState;
// if not in react native, just use local storage
var AsyncStorage = JS_1.default.browserOrNode().isBrowser ? new StorageHelper_1.default().getStorage() : undefined;
exports.AsyncStorage = AsyncStorage;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@aws-amplify/core/lib/RNComponents/index.js
// module id = 510
// module chunks = 0